const paymentBracketMidPoints = {
    "0 < x < 2000": 1000,
    "2000 <= x < 4000": 3000,
    "4000 <= x < 8000": 6000,
    "8000 <= x < 12000": 10000,
    "12000 <= x ": 14000,
};

const generateOptions = (bracketMidPoint) => {
    return [
        bracketMidPoint * 0.2 - 1,
        bracketMidPoint * 0.4 - 1,
        bracketMidPoint * 0.6 - 1,
    ];
};

export const getUpfrontPaymentOptions = (device) => {
    if (!device) {
        return [];
    }

    const price = device.Price;

    if (price < 2000) {
        return generateOptions(paymentBracketMidPoints["0 < x < 2000"]);
    }
    if (price < 4000) {
        return generateOptions(paymentBracketMidPoints["2000 <= x < 4000"]);
    }
    if (price < 8000) {
        return generateOptions(paymentBracketMidPoints["4000 <= x < 8000"]);
    }
    if (price < 12000) {
        return generateOptions(paymentBracketMidPoints["8000 <= x < 12000"]);
    }
    if (price >= 12000) {
        return generateOptions(paymentBracketMidPoints["12000 <= x "]);
    }
};
